import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=df526130&scoped=true&"
import script from "./AdminProfile.vue?vue&type=script&lang=js&"
export * from "./AdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=df526130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df526130",
  null
  
)

export default component.exports